import { Component, OnInit, Input } from '@angular/core';
import { CorizeBaseComponent } from '../../models/base-corize-component';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css']
})
export class LoadingComponent extends CorizeBaseComponent implements OnInit {

  @Input() message:string;
  constructor() {
    super();
  }

  ngOnInit() {
  }
}